/**
 * 
 * @author laya
 */
export class RenderInfo {
    /**当前帧的开始时间 */
    static loopStTm: number = 0;
    /**主舞台 <code>Stage</code> 渲染次数计数。 */
    static loopCount: number = 0;
}